import OrdineSingoloChoiceArticolo from "./OrdineSingoloChoiceArticolo";

export default class Choice {
    nome: string;
    sezioneAggiuntivaId: number;
    ordineSingoloChoiceArticoloList: OrdineSingoloChoiceArticolo[];

    constructor() {
        this.nome = "";
        this.sezioneAggiuntivaId = 0;
        this.ordineSingoloChoiceArticoloList = [];
    }

    static convertFromFirestore(choice: firebase.firestore.DocumentData): Choice {
        let result: Choice = new Choice();
        result.nome = choice.nome;
        result.sezioneAggiuntivaId = choice.sezioneAggiuntivaId;
        if (choice.ordineSingoloChoiceArticoloList) {
            choice.ordineSingoloChoiceArticoloList.forEach((choice: any) => {
                result.ordineSingoloChoiceArticoloList.push(OrdineSingoloChoiceArticolo.convertFromFirestore(choice));
            });
        }
        return result;
    }

    static convertToFirestore(object: Choice): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.nome = object.nome;
        result.ordineSingoloChoiceArticoloList = [];
        result.sezioneAggiuntivaId = object.sezioneAggiuntivaId;
        if (object.ordineSingoloChoiceArticoloList) {
            object.ordineSingoloChoiceArticoloList.forEach((choice: any) => {
                result.ordineSingoloChoiceArticoloList.push(OrdineSingoloChoiceArticolo.convertToFirestore(choice));
            });
        }
        return result;
    }
}